export const TypeNotify = {
    SUCCESS: 1,
    ERROR: 0,
};
